import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { UpdateInfoIndividual } from "src/app/parametrage/core/model/individual/update-info-individual";

@Component({
  selector: "app-update-info-individual",
  templateUrl: "./update-info-individual.component.html",
  styleUrls: ["./update-info-individual.component.scss"],
})
export class UpdateInfoIndividualComponent implements OnInit {
  @Input() individualId;

  individual: Individual;

  customer: UpdateInfoIndividual = new UpdateInfoIndividual();

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _individualService: IndividualService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      customerCode: [null, Validators.compose([Validators.required])],
      codeAgenceDomiciliation: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      codeGestionnaireDomiciliation: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      rib: [null, Validators.compose([Validators.nullValidator])],
      numeroCompte: [null, Validators.compose([Validators.nullValidator])],
      categorie: [null, Validators.compose([Validators.required])],
      matricule: [null, Validators.compose([Validators.nullValidator])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],

      email: [null, Validators.compose([Validators.nullValidator])],
      situationMatrimoniale: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      adressePostale: [null, Validators.compose([Validators.nullValidator])],
      adresseGeographique: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      homePhone: [null, Validators.compose([Validators.nullValidator])],
      mobilePhone: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {
    this.getIndividualById(this.individualId);
  }

  getIndividualById(individualId) {
    this._individualService.getIndividualById(individualId).subscribe(
      (data) => {
        this.individual = data;
        this.customer.individualId = this.individual.id;
        this.customer.customerCode = this.individual.customerCode;
        this.customer.codeAgenceDomiciliation =
          this.individual.codeAgenceDomiciliation;
        this.customer.rib = this.individual.rib;
        this.customer.numeroCompte = this.individual.numeroCompte;
        this.customer.categorie = this.individual.categorie;
        this.customer.matricule = this.individual.matricule;
        this.customer.firstname = this.individual.firstname;
        this.customer.lastname = this.individual.lastname;
        this.customer.email = this.individual.email;
        this.customer.situationMatrimoniale =
          this.individual.situationMatrimoniale;
        this.customer.adressePostale = this.individual.adressePostale;
        this.customer.adresseGeographique = this.individual.adresseGeographique;
        this.customer.homePhone = this.individual.homePhone;
        this.customer.mobilePhone = this.individual.mobilePhone;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this._individualService
      .updateInfo(this.customer)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
